<div [style.padding-left.rem]="depth * 1.5">
    <div 
      (click)="onNodeClick(node, $event)"
      class="flex items-center p-2 rounded-md cursor-pointer group hover:bg-gray-100"
      [class.bg-blue-100]="node.id === activeNodeId"
      [class.text-blue-600]="node.id === activeNodeId">
  
      <div class="w-6 text-center">
        <svg *ngIf="node.children && node.children.length > 0" 
             xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" 
             class="w-4 h-4 transition-transform"
             [class.rotate-90]="node.isExpanded">
          <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
        </svg>
      </div>
  
      <span class="flex-1">{{ node.label }}</span>
    </div>
  </div>
  
  <div *ngIf="node.children && node.children.length > 0" 
       class="transition-all duration-300 ease-in-out"
       [class.max-h-0]="!node.isExpanded"
       [class.max-h-screen]="node.isExpanded"
       [style.overflow]="'hidden'">
    
    <app-tree-node 
      *ngFor="let child of node.children" 
      [node]="child"
      [depth]="depth + 1"
      [activeNodeId]="activeNodeId"
      (nodeClicked)="onNodeClick($event.node, $event.event)">
    </app-tree-node>
  </div>